export default __webpack_public_path__ + "static/media/Logo-largo-dorado-sm.504e16f3.jpg";